import { AoPath } from './ao-path';
import { PathPointBbx } from './path-point/path-point-bbx';
import { GmapsPolyline } from '@infodata-group/inf-commons-tools';
import { SettingsService } from '@infodata-group/inf-commons';
import { PreferencesSettingsKeyEnum } from '../../enum/preferences-settings-key.enum';
import { PathMarkerBbx } from './path-marker/path-marker-bbx';
import { AoSharedTools } from '../../engine/tools/ao-shared-tools';
import SymbolPath = google.maps.SymbolPath;

export class AoPathBbx extends AoPath {
  public override pathPoint: PathPointBbx[];
  public override markers: PathMarkerBbx[];
  public override displayedMarkers: PathMarkerBbx[];

  constructor(id: string, date: Date, pathPoint: PathPointBbx[]) {
    super(id, date, pathPoint);
  }

  public generatePolyline(settingsService: SettingsService) {
    const colors = AoSharedTools.getColorPath(
      settingsService.getSetting(PreferencesSettingsKeyEnum.speedAndColor),
    );
    const polylines: GmapsPolyline[] = [];

    let polyline = new GmapsPolyline('', '', []);
    let previousInteval: string;
    let number = 0;
    polyline.setIcon(SymbolPath.FORWARD_CLOSED_ARROW);
    this.pathPoint.forEach((p, index) => {
      let color = '#000000';
      let interval: string;
      const matchColor = colors.find(
        (c) => c.speedMin <= p.vitesse && p.vitesse <= c.speedMax,
      );
      if (matchColor) {
        color = matchColor.color;
        interval = JSON.stringify(matchColor);
      }
      if (
        (interval === previousInteval && index > 0) ||
        number > 5 ||
        this.pathPoint.length === 5
      ) {
        polylines.push(polyline);
        polyline = new GmapsPolyline('', '', [
          this.pathPoint[index - 1].toGmapsPoint(),
        ]);
        polyline.options = { strokeWeight: 1.75 };
        polyline.setIcon(SymbolPath.FORWARD_CLOSED_ARROW);
        previousInteval = interval;
        number = 0;
      }
      polyline.setColor(color);
      polyline.points.push(p.toGmapsPoint());
      number++;
    });
    polylines.push(polyline);
    this.polyline = this.displayedPolyline = polylines;
  }

  public override generatePathMarker(pathPoint: PathPointBbx): PathMarkerBbx {
    return new PathMarkerBbx('', pathPoint);
  }
}
